import { kebabCase } from 'lodash-es';
import { FLSA_SECTIONS } from '@/helpers/constants/flsaQuestions';

export const FLSA_ALERT_LABELS = {
  up_to_date: 'OK',
  no_flsa_submission: 'No submission',
  review_overdue: 'Overdue',
  status_mismatch: 'Mismatched status',
  outdated_form: 'Outdated form',
};

export const FLSA_ALERT_ICONS = {
  up_to_date: 'flsa-check-circle-outline',
  no_flsa_submission: 'flsa-file-x',
  outdated_form: 'flsa-calendar-alert-outline',
  status_mismatch: 'flsa-sync-problem',
  review_overdue: 'flsa-timer-sand-complete',
};

const HIDDEN_ALERT_TYPES = new Set(['profile_change']);

export const formatJurisdictionLabel = (jurisdiction) => (
  jurisdiction
    ? jurisdiction.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
    : ''
);

export const formatExemptionBasis = (category) => {
  if (!category) return '';

  const id = kebabCase(category);
  const match = FLSA_SECTIONS.find((section) => section.id === id);

  return match?.title ?? '';
};

export const getFederalJurisdiction = (item) => item?.jurisdictions?.federal ?? null;

export const getFederalAlerts = (item) => getFederalJurisdiction(item)?.alerts ?? [];

export const getFederalLatestSubmission = (item) => (
  getFederalJurisdiction(item)?.latest_submission ?? null
);

export const getProfileAlertStatus = (item) => {
  const federal = getFederalJurisdiction(item);

  if (!federal) {
    return { key: null, label: '' };
  }

  if (federal.is_up_to_date) {
    return { key: 'up_to_date', label: FLSA_ALERT_LABELS.up_to_date };
  }

  const alertTypes = (federal.alerts ?? []).filter(
    (alertType) => !HIDDEN_ALERT_TYPES.has(alertType),
  );

  if (!alertTypes.length) {
    return { key: null, label: '' };
  }

  if (alertTypes.length > 1) {
    return { key: 'multiple', label: 'Multiple' };
  }

  const alertType = alertTypes[0];

  return {
    key: alertType,
    label: FLSA_ALERT_LABELS[alertType] || alertType,
  };
};

export const getJurisdictionsList = (jurisdictions = {}) => (
  Object.keys(jurisdictions)
    .map(formatJurisdictionLabel)
    .sort()
);
